import { BrowserKinds, BrowserUtility } from "./BrowserUtility";
import { LoggerFactory } from "./logger";

export interface IClipboardAccessible {
  writeSelectedText(): Promise<void>;
  readText(): Promise<string>;
}

abstract class AbstractClipboardAccessor implements IClipboardAccessible {
  async writeSelectedText(): Promise<void> {
    document.execCommand("copy");
  }

  async abstract readText(): Promise<string>;
}

class StandardAccessor extends AbstractClipboardAccessor {
  async readText(): Promise<string> {
    if (!navigator.clipboard) {
      // Chromeではlocalhost以外ではhttps通信ではないとクリップボードにアクセスできない
      LoggerFactory.getLogger().debug("navigator.clipboardが生成されていません。");
      return null;
    }
    return navigator.clipboard.readText();
  }
}

class InternetExplorerClipboardAccessor extends AbstractClipboardAccessor {
  async readText(): Promise<string> {
    return (window as any).clipboardData.getData("Text");
  }
}

export class ClipboardUtility {
  static createAccessor(): IClipboardAccessible {
    const accessor = ClipboardUtility._accessors[BrowserUtility.getBrowserKind()];
    return !!accessor
      ? accessor
      : ClipboardUtility._accessors[BrowserKinds.Unknown];
  }

  private static readonly _accessors: { [key: number]: IClipboardAccessible } = ClipboardUtility.createAccessors();

  private static createAccessors(): { [key: number]: IClipboardAccessible } {
    const results: { [key: number]: IClipboardAccessible } = {};
    results[BrowserKinds.Unknown] = new StandardAccessor();
    results[BrowserKinds.GoogleChrome] = new StandardAccessor();
    results[BrowserKinds.ChromiumEdge] = new StandardAccessor();
    results[BrowserKinds.InternetExplorer] = new InternetExplorerClipboardAccessor();
    return results;
  }
}
